<template>
    <div class="table">
        <el-table id="dataTable" :data="tableData" :border="border" :stripe="stripe" style="width: 100%;height:100%"
            height="500" :default-sort="defaultSort" :sortable="true" v-loading="isLoading"
            :highlight-current-row="false" :row-class-name="rowClassName" @selection-change="handleSelectionChange"
            :row-style="rowStyle">
            <slot></slot>
            <template #empty>
                <el-empty description="暂无数据，请查询" :image-size="300" />
            </template>
        </el-table>
    </div>
    <div class="pagination" v-if="isShowPagination">
        <el-pagination v-model:currentPage="currentPage" v-model:page-size="pageSize" :background="true"
            layout="prev,next, jumper, slot" :total="total" :hide-on-single-page="false" v-if="isSimplePagination">
            <el-icon @click="refresh" style="cursor:pointer">
                <Refresh />
            </el-icon>
        </el-pagination>
        <el-pagination v-model:currentPage="currentPage" v-model:page-size="pageSize" :background="true"
            layout="total,prev, pager, next, jumper, slot" :total="total" :hide-on-single-page="false" v-else>
            <el-icon @click="refresh" style="cursor:pointer">
                <Refresh />
            </el-icon>
        </el-pagination>
    </div>
</template>

<script>
import { Refresh } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import request from '@/request/request'
export default {
    emits: ['rowClassName', 'selectionRows'],
    props: {
        tableDataUrl: {
            default: ''
        },
        tableDataOrigin: {
            default: ''
        },
        border: {
            default: false
        },
        stripe: {
            default: false
        },
        defaultSort: {
            default: {}
        },
        isShowPagination: {
            type: Boolean,
            default: true
        },
        isSimplePagination: {
            type: Boolean,
            default: true
        },
        isLoadData: {
            type: Boolean
        },
        rowStyle: {
            type: Function,
            default: () => { }
        }
    },
    components: {
        Refresh
    },
    data() {
        return {
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: this.isSimplePagination ? 99999999999999 : 0,
            params: {},
            isLoading: false,
            customLoad: false,
            requestUrl: '',
        }
    },
    watch: {
        currentPage(page) {
            this.showPage(page)
        }
    },
    mounted() {
        this.showPage()
    },
    methods: {
        async showPage(page = 1) {
            if (this.customLoad || this.isLoadData) {
                this.isLoading = true

                /**
                 * 直接传入数据，不请求
                 */
                if (this.tableDataOrigin) {
                    this.tableData = this.tableDataOrigin
                    this.isLoading = false
                }

                let params = {}
                if (this.isShowPagination) {
                    params = Object.assign(this.params, { pageSize: this.pageSize, page: page, current: this.currentPage })
                } else {
                    params = this.params
                }

                /**
                 * 传入的request请求方法
                 */
                if (this.tableDataUrl) {
                    await this.tableDataUrl(params).then(r => {
                        this.setTableDataList(r)
                    })
                }

                /**
                 * 传入的url地址
                 */
                if (this.requestUrl) {
                    await request.getAsync(this.requestUrl, this.params).then(r => {
                        this.setTableDataList(r)
                    })
                }
            }
        },
        refresh() {
            this.showPage(this.currentPage)
        },
        search(params) {
            this.params = params
            this.showPage()
        },
        setTableData(data) {
            this.tableData = data
            this.isLoading = false
        },
        setRequestUrl(url) {
            this.requestUrl = url
        },
        setCustomLoad(load) {
            this.customLoad = load
        },
        setParams(params) {
            this.search(params)
        },
        setTableDataList(response) {
            if (response && response.status == 200) {
                this.tableData = response.data
                if (this.isShowPagination && response.pagination && !this.isSimplePagination) {
                    this.pageSize = response.pagination.perPage
                    this.currentPage = response.pagination.currentPage
                    this.total = response.pagination.total
                }
            } else {
                ElMessage({
                    message: '请求错误',
                    type: 'error'
                })
            }
            this.isLoading = false
        },
        rowClassName(row) {
            this.$emit('rowClassName', row)
        },
        handleSelectionChange(rows) {
            this.$emit('selectionRows', rows)
        }
    }
}
</script>

<style scoped>
.pagination {
    margin-top: 30px;
}

/* 当鼠标悬停在表格的行上时改变背景色 */
.el-table {
    --el-table-row-hover-bg-color: #cde8f8;
}

/* 滚动条整体部分 */
::v-deep .el-scrollbar__bar {
    opacity: 1;
    /* 使滚动条不透明 */
}

/* 横向滚动条的滑块 */
::v-deep .el-scrollbar__bar.is-horizontal .el-scrollbar__thumb {
    border-radius: 1px;
    /* 滑块的圆角 */
    background-color: #818181;
    /* 滑块的背景颜色 */
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
    /* 滑块的阴影 */
}

/* 纵向滚动条的滑块 */
::v-deep .el-scrollbar__bar.is-vertical .el-scrollbar__thumb {
    border-radius: 1px;
    background-color: #818181;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
}

/* 滚动条的轨道部分 */
::v-deep .el-scrollbar__wrap {
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        /* 轨道的背景颜色 */
    }
}

/* 修改滑块宽度 */
::v-deep .el-scrollbar__bar.is-horizontal {
    height: 12px;
}

::v-deep .el-scrollbar__bar.is-vertical {
    width: 12px;
}
</style>
